export const key = Symbol();
